// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"539":"9b1fb14e","843":"dd470911"}[chunkId] + ".chunk.js";
};